$(document).ready(function(){
  var filterTimer = null;
  var filterXhr = null;

  // Use event delegation for filter buttons so we don't need to re-attach after AJAX
  $(document.body).on('click', '#filter-button', function() {
    var container = document.querySelector('.Collection-sidebar');
    var backdrop = document.getElementById('backdrop');
    if (container) container.classList.toggle('filter-active');
    if (backdrop) backdrop.style.display = 'block';
    var filter = document.getElementById('filter');
    if (filter) filter.style.animationName = 'slide-up';
  });
  $(document.body).on('click', '#close-filter-button, #backdrop', function() {
    var container = document.querySelector('.Collection-sidebar');
    var backdrop = document.getElementById('backdrop');
    if (container) container.classList.remove('filter-active');
    if (backdrop) backdrop.style.display = 'none';
    var filter = document.getElementById('filter');
    if (filter) filter.style.animationName = 'slideDown';
  });

  $(document.body).on('change','#FacetFiltersForm', function(){
    var t = $(this),
       f = t.serialize();
    window.history.pushState('page2', 'Title', '?'+f);
    clearTimeout(filterTimer);
    if (filterXhr) filterXhr.abort();
    filterTimer = setTimeout(function(){
      $('.loading-modal').show();
      $('.px-infinite-scrolling').html('');
      filterXhr = $.ajax({
          type: "get",
          url: '?'+f+'&section_id=product-grid',
          success: function (data) {
            var result = $(data).find('.product-grid-container').html();
            $('#ProductGridContainer').html(result);
          },
          error: function (xhr, text) {},
          complete: function () { filterXhr = null; }
      });
    }, 150);
  });
})
